import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { SectionCard } from './Common';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

/**
 * Los atajos del concepto de un cobro (`cobro_presets`): cada concepto con su
 * importe fijo, o sin importe («importe manual»). Son las opciones del
 * desplegable de Cobros y de los pagos de un presupuesto; con importe, se
 * rellena solo al elegirlo. Sin ninguno, el concepto se escribe a mano.
 * Se guarda con el resto de la Configuración.
 */
export default function AjustesCobros({ form, setF, soloLectura }) {
  const lista = Array.isArray(form.cobro_presets) ? form.cobro_presets : [];
  const guardar = (nueva) => setF('cobro_presets', nueva);
  const cambiar = (i, campo, valor) => guardar(lista.map((c, j) => (j === i ? { ...c, [campo]: valor } : c)));
  const importe = (valor) => {
    const limpio = String(valor).replace(',', '.').trim();
    if (!limpio) return null;
    const n = Number(limpio);
    return Number.isFinite(n) && n > 0 ? n : null;
  };
  return (
    <SectionCard title="Conceptos de cobro">
      <div className="space-y-3" data-testid="settings-cobro-presets">
        <p className="text-sm text-muted-foreground">
          Los conceptos que se ofrecen al apuntar un cobro. Con importe, se rellena solo al
          elegirlo (y se puede cambiar); sin importe, se escribe cada vez. Sin ninguno, el
          concepto se escribe a mano.
        </p>
        {lista.map((c, i) => (
          <div key={i} className="grid grid-cols-1 md:grid-cols-[2fr_1fr_auto] gap-2 items-end" data-testid={`settings-cobro-preset-${i}`}>
            <div>
              <Label>Concepto</Label>
              <Input disabled={soloLectura} value={c.concepto || ''} onChange={(e) => cambiar(i, 'concepto', e.target.value)} data-testid={`settings-cobro-preset-concepto-${i}`} />
            </div>
            <div>
              <Label>Importe (€)</Label>
              <Input disabled={soloLectura} type="number" min="0" step="0.01" placeholder="Manual"
                value={c.importe ?? ''} onChange={(e) => cambiar(i, 'importe', importe(e.target.value))}
                data-testid={`settings-cobro-preset-importe-${i}`} />
            </div>
            {!soloLectura && (
              <Button type="button" variant="ghost" aria-label="Quitar concepto" onClick={() => guardar(lista.filter((_, j) => j !== i))} data-testid={`settings-cobro-preset-quitar-${i}`}>
                <Trash2 className="w-4 h-4" />
              </Button>
            )}
          </div>
        ))}
        {!soloLectura && (
          <Button type="button" variant="outline" disabled={lista.some((c) => !String(c.concepto || '').trim())}
            onClick={() => guardar([...lista, { concepto: '', importe: null }])} data-testid="settings-cobro-preset-anadir">
            <Plus className="w-4 h-4 mr-2" /> Añadir concepto
          </Button>
        )}
      </div>
    </SectionCard>
  );
}
